import state from './whitelists.state'
import mutations from './whitelists.mutations'
import actions from './whitelists.actions'
import getters from './whitelists.getters'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
